import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { INNER_BOTTOM_SPACE_DESK } from '../../theme';

const useStyles = (background, isPortraitOrientation, videoWidth, hasMaxWidth) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: 36,
        paddingBottom: 36,
        background: theme.palette.secondary.dark,
        '&:first-child': {
          marginTop: 76,
        },

        '& .swiper-container::after': {
          content: '""',
          display: 'block',
          position: 'absolute',
          ...(isPortraitOrientation ? { top: 0 } : { bottom: 0 }),
          right: -1,
          width: 50,
          height: isPortraitOrientation ? 225 : '100%',
          background:
            background === 'Dark'
              ? `transparent linear-gradient(-90deg, ${theme.palette.secondary.dark} 0%, rgba(27,25,37,0) 100%) 0% 0% no-repeat padding-box`
              : `transparent linear-gradient(-90deg, ${theme.palette.secondary.light} 0%, rgba(35,32,46,0) 100%) 0% 0% no-repeat padding-box`,
          zIndex: 3,
        },

        [theme.breakpoints.up('sm')]: {
          paddingTop: 72,
          paddingBottom: 72,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
          '&:first-child': {
            marginTop: 120,
          },

          '& .swiper-container::after': {
            height: '100%',
            opacity: isPortraitOrientation ? 0 : 1,
          },
        },
      },
      container: {
        paddingRight: 0,
        [theme.breakpoints.up('sm')]: {
          paddingRight: isPortraitOrientation ? 16 : 0,
        },
      },
      heading: {
        margin: 'auto',
        marginBottom: 22,
        [theme.breakpoints.up('sm')]: {
          maxWidth: 500,
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
      },
      videoWrapper: {
        overflow: 'hidden',
        transition: hasMaxWidth ? 'none' : 'height .3s, width .3s',
        maxWidth: hasMaxWidth ? '20%' : 'none',
        marginRight: hasMaxWidth ? '2%' : 'none',

        [theme.breakpoints.up('md')]: {
          height: 316,

          '&:hover': isPortraitOrientation
            ? {}
            : {
                height: '100%',
                width: `${videoWidth + videoWidth * 0.2}px !important`,
              },
        },
      },
      pathwayWrapper: {
        transition: hasMaxWidth ? 'none' : 'height .3s, width .3s',
        maxWidth: hasMaxWidth ? '20%' : 'none',
        marginRight: hasMaxWidth ? '2%' : 'none',
        padding: '20px 0 0 0',

        '& > div': {
          marginRight: 24,
        },

        [theme.breakpoints.up('md')]: {
          height: 316,

          '&:hover': isPortraitOrientation
            ? {}
            : {
                height: '100%',
                width: `${videoWidth + videoWidth * 0.2}px !important`,
              },
        },
      },
    }),
  );
export default useStyles;
